// import { MdAdd, MdDeleteForever } from "react-icons/md";
// import { FiMinus } from "react-icons/fi";
// import { useState, useEffect, useCallback } from "react";
// import { useDispatch } from 'react-redux';
// import { deleteCartItem, putCartItem } from "../../../redux/slices/addToCart";
// import { toast } from 'react-toastify';
// import { RxCross2 } from "react-icons/rx";
// import { Modeldelete, Modelminidelete } from "../basic/model";

// export default function ShoppingCartTable({ shoppingcart, minicart, cartIsLoading, cartErorr }) {

//     const BASE_IMAGE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

//     const dispatch = useDispatch();

//     const [cartItems, setCartItems] = useState([]);
//     const [loading, setLoading] = useState(true);

//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [cartitemId, setCartItemId] = useState(null);

//     const openModal = (id) => {

//         setCartItemId(id);
//         setIsModalOpen(true);
//     };

//     const closeModal = () => {
//         setIsModalOpen(false);
//         setCartItemId(null);
//     };

//     useEffect(() => {
//         const timer = setTimeout(() => {
//             setLoading(false);
//         }, 1000);
//         return () => clearTimeout(timer);
//     }, []);

//     useEffect(() => {
//         setCartItems(shoppingcart);
//     }, [shoppingcart]);

//     // Handle increment logic
//     const handleIncrement = useCallback((itemId) => {
//         setCartItems((prevItems) => {
//             const updatedItems = prevItems.map(item => {
//                 if (item.id === itemId) {
//                     const newQuantity = item.quantity + 1;
//                     const newTotalPrice = item.discount
//                         ? item.discount * newQuantity
//                         : item.price * newQuantity;

//                     return {
//                         ...item,
//                         quantity: newQuantity,
//                         totalPrice: newTotalPrice
//                     };
//                 }
//                 return item;
//             });

//             return updatedItems;
//         });
//     }, []);

//     // Handle decrement logic
//     const handleDecrement = useCallback((itemId) => {
//         setCartItems((prevItems) => {
//             const updatedItems = prevItems.map(item => {
//                 if (item.id === itemId && item.quantity > 1) {
//                     const newQuantity = item.quantity - 1;
//                     const newTotalPrice = item.discount
//                         ? item.discount * newQuantity
//                         : item.price * newQuantity;

//                     return {
//                         ...item,
//                         quantity: newQuantity,
//                         totalPrice: newTotalPrice
//                     };
//                 }
//                 return item;
//             });

//             return updatedItems;
//         });
//     }, []);

//     // Update the cart item
//     const handleUpdate = (itemId, quantity, totalPrice) => {
//         const cart_id = localStorage?.getItem('cart_id') || null;
//         const payload = {
//             item_id: itemId,
//             quantity,
//             total_prize: totalPrice,
//             ...(cart_id && { cart_id }),
//         };
//         dispatch(putCartItem(itemId, payload, toast));
//     };

//     const handleDelete = useCallback(async () => {
//         try {
//             console.log("cartitemId", cartitemId)
//             dispatch(deleteCartItem(cartitemId, toast));
//             const filterData = cartItems.filter((item) => item?.id !== cartitemId);
//             setCartItems(filterData);
//         } catch (error) {
//             console.error("Error handling delete operation:", error);
//             toast.error("There was an issue deleting the item.");
//         } finally {
//             closeModal();
//         }

//     }, [dispatch, cartitemId, closeModal]);

//     return (

//         <>
//             {minicart ? (
//                 <div className="mt-4 max-h-[450px] overflow-y-auto">
//                     {loading || cartIsLoading ? (
//                         <SkeletonLoader cartItems={cartItems} />
//                     ) : (cartItems.map((item, index) => (
//                         <div
//                             className={`flex shadow-md rounded-lg justify-between relative my-4  ${index % 2 === 0 ? '' : 'bg-gray-100'}`}
//                             key={index}>

//                             <div className="flex items-center justify-center cursor-pointer h-8 w-8 rounded-md absolute right-[10px] top-[20px] p-2 bg-[#00000054]" onClick={() => openModal(item?.id)}>
//                                 <RxCross2 className='text-2xl text-[#072320]' />
//                             </div>

//                             <div className="flex items-center py-4 px-4 gap-4">
//                                 <div className='rounded-md w-24 h-24 bg-[#00a762b0]  p-2'>
//                                     <img
//                                         src={BASE_IMAGE_URL + item?.additional_images[0]}
//                                         alt='product_img'
//                                         className='h-full w-full rounded-md'
//                                     />
//                                 </div>

//                                 <div className="flex justify-center flex-col gap-1">
//                                     <h2 className="text-[#00A762] text-left font-dm text-lg capitalize font-medium">
//                                         {item?.name}
//                                     </h2>

//                                     <h2 className="text-[#072320] whitespace-nowrap  text-left font-dm text-md capitalize font-medium">
//                                         Quantity : {item?.quantity}
//                                     </h2>
//                                     <h2 className="text-[#072320] whitespace-nowrap  text-left font-dm text-md capitalize font-medium">
//                                         {item?.discount ? (
//                                             <p className="text-base font-dm">
//                                                 Unit Prize : ₹{item.discount}
//                                             </p>
//                                         ) : (
//                                             <p className="text-base font-dm">
//                                                 Unit Prize : ₹{item.price}
//                                             </p>
//                                         )}
//                                     </h2>
//                                 </div>
//                             </div>
//                         </div>
//                     ))
//                     )}
//                 </div>
//             ) : (
//                 <>
//                     {loading || cartIsLoading ? (
//                         <SkeletonTable cartItems={cartItems} />
//                     ) : (
//                         <div className="overflow-x-auto">
//                             <table className="min-w-full bg-white border border-gray-200 shadow-md rounded-lg">
//                                 <thead className="bg-gray-100">
//                                     <tr>
//                                         <th className="py-2 px-4 font-dm text-[#00A762] capitalize md:block hidden">Image</th>
//                                         <th className="py-2 px-4 font-dm text-[#00A762] capitalize">Name</th>
//                                         <th className="py-2 px-4 font-dm text-[#00A762] capitalize">Prize of the Month</th>
//                                         <th className="py-2 px-4 font-dm text-[#00A762] capitalize">Quantity</th>
//                                         <th className="py-2 px-4 font-dm text-[#00A762] capitalize">Total Price</th>
//                                         <th className="py-2 px-4 font-dm text-[#00A762] capitalize" colSpan={2}>Actions</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {cartItems.map((item, index) => (
//                                         <tr key={item.id} className={index % 2 === 0 ? '' : 'bg-gray-100'}>
//                                             <td className="py-2 px-4 md:block hidden">
//                                                 <img
//                                                     src={BASE_IMAGE_URL + item?.additional_images[0]}
//                                                     alt="product_img"
//                                                     className="h-24 w-32 object-cover rounded-md"
//                                                 />
//                                             </td>
//                                             <td className="py-2 px-4 text-[#00A762] text-left font-dm text-lg capitalize font-medium">
//                                                 {item?.name}
//                                             </td>
//                                             <td className="py-2 px-4 text-[#072320] text-left font-dm text-md capitalize font-medium">
//                                                 ₹{item?.discount ? item.discount : item.price}
//                                             </td>
//                                             <td className="py-2 px-4">
//                                                 <div className="flex items-center justify-center gap-1">
//                                                     <button
//                                                         className="btn_plus hover:bg-gray-200 hover:rounded-l-lg"
//                                                         type="button"
//                                                         onClick={() => handleIncrement(item?.id)}
//                                                     >
//                                                         <MdAdd className="text-[#00A762]" />
//                                                     </button>
//                                                     <input
//                                                         className="w-12 text-center bg-transparent border border-gray-300 rounded"
//                                                         value={item?.quantity}
//                                                         readOnly
//                                                     />
//                                                     <button
//                                                         className="btn_minus hover:bg-gray-200 hover:rounded-r-lg"
//                                                         type="button"
//                                                         onClick={() => handleDecrement(item?.id)}
//                                                     >
//                                                         <FiMinus style={{ color: '#00A762' }} />
//                                                     </button>
//                                                 </div>
//                                             </td>
//                                             <td className="py-2 px-4 text-base font-dm">
//                                                 ₹{item?.totalPrice}
//                                             </td>

//                                             <td className="py-2 cursor-pointer" onClick={() => handleUpdate(item?.id, item?.quantity, item?.totalPrice)}>
//                                                 <h1 className="text-[#00A762] font-dm">Update</h1>
//                                             </td>

//                                             <td className="py-2 cursor-pointer"
//                                                 onClick={() => openModal(item?.id)}

//                                             >
//                                                 <MdDeleteForever className="text-[#00A762] text-2xl" />
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     )}
//                 </>
//             )}

//             {minicart ? (
//                 <Modelminidelete
//                     isOpen={isModalOpen}
//                     onClose={closeModal}
//                     onConfirm={handleDelete}
//                 />
//             ) : (
//                 <Modeldelete
//                     isOpen={isModalOpen}
//                     onClose={closeModal}
//                     onConfirm={handleDelete}
//                 />
//             )}
//         </>

//     );
// }

// const SkeletonRow = () => (
//     <tr className="animate-pulse">
//         <td className="py-2 px-2">
//             <div className="bg-gray-200 h-24 w-32 rounded-md"></div>
//         </td>
//         <td className="py-2 px-2">
//             <div className="bg-gray-200 h-6 w-32 rounded-md"></div>
//         </td>
//         <td className="py-2 px-2">
//             <div className="bg-gray-200 h-6 w-24 rounded-md"></div>
//         </td>
//         <td className="py-2 px-2">
//             <div className="bg-gray-200 h-6 w-24 rounded-md"></div>
//         </td>
//         <td className="py-2 px-2">
//             <div className="bg-gray-200 h-6 w-24 rounded-md"></div>
//         </td>
//         <td className="py-2 px-2 ">
//             <div className="bg-gray-200 h-6 w-6 rounded-md float-left"></div>
//             <div className="bg-gray-200 h-6 w-6 rounded-md float-right"></div>
//         </td>
//     </tr>
// );

// const SkeletonTable = ({ cartItems }) => (
//     <div className="overflow-x-auto">
//         <table className="min-w-full bg-white border border-gray-200 shadow-md rounded-lg">
//             <thead className="bg-gray-100">
//                 <tr>
//                     <th className="py-2 px-4 font-dm text-[#00A762] capitalize h-full md:block hidden">Image</th>
//                     <th className="py-2 px-4 font-dm text-[#00A762] capitalize">Name</th>
//                     <th className="py-2 px-4 font-dm text-[#00A762] capitalize">Prize of the Month</th>
//                     <th className="py-2 px-4 font-dm text-[#00A762] capitalize">Quantity</th>
//                     <th className="py-2 px-4 font-dm text-[#00A762] capitalize">Total Price</th>
//                     <th className="py-2 px-4 font-dm text-[#00A762] capitalize" colSpan={2}>Actions</th>
//                 </tr>
//             </thead>
//             <tbody>
//                 {cartItems.map((_, index) => (
//                     <SkeletonRow key={index} />
//                 ))}
//             </tbody>
//         </table>
//     </div>
// );

// const SkeletonLoader = ({ cartItems }) => {
//     return (
//         <div className="space-y-4">
//             {cartItems.map((_, index) => (
//                 <div key={index} className="flex items-center gap-4 p-4 border border-gray-200 rounded-lg shadow-md animate-pulse">
//                     <div className="w-24 h-24 bg-gray-300 rounded-md"></div>
//                     <div className="flex-1 space-y-4">
//                         <div className="h-4 bg-gray-300 rounded"></div>
//                         <div className="h-4 bg-gray-300 rounded w-3/4"></div>
//                         <div className="h-4 bg-gray-300 rounded w-1/2"></div>
//                     </div>
//                 </div>
//             ))}
//         </div>
//     );
// };

import { MdAdd, MdDeleteForever } from "react-icons/md";
import { FiMinus } from "react-icons/fi";
import { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  deleteCartItem,
  PostAddSalectItems,
  putCartItem,
} from "../../../redux/slices/addToCart";
import { toast } from "react-toastify";
import { RxCross2 } from "react-icons/rx";
import { Modeldelete, Modelminidelete } from "../basic/model";
import { FormProvider } from "react-hook-form";

export default function ShoppingCartTable({
  shoppingcart,
  minicart,
  cartIsLoading, 
}) {
const BASE_IMAGE_URL = process.env.REACT_APP_BASE_IMAGE_URL;
  const dispatch = useDispatch();

  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cartitemId, setCartItemId] = useState(null);
  const [selectedItems, setSelectedItems] = useState({});
  const openModal = (id) => {
    setCartItemId(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCartItemId(null);
  };

  useEffect(() => {
    setCartItems(shoppingcart);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [shoppingcart]);

  const handleIncrement = useCallback((itemId, itemPrice) => {
  setCartItems((prevItems) => {
    const updatedItems = prevItems.map((item) => {
      if (item.id === itemId.id) {
          const newQuantity = item.quantity + 1;
          const newTotalPrice = newQuantity * itemPrice;
  
          const updatedItem = {
            ...item,
            quantity: newQuantity,
            totalPrice: newTotalPrice,
          };
  
          const storedQty = JSON.parse(localStorage.getItem("cart_quantities")) || {};
          storedQty[itemId.item_id] = newQuantity;
          localStorage.setItem("cart_quantities", JSON.stringify(storedQty));
  
          return updatedItem;
        }
        return item;
      });
      return updatedItems;
    });
  }, []);

  const handleDecrement = useCallback((itemId, itemPrice) => {
    setCartItems((prevItems) => {
      const updatedItems = prevItems.map((item) => {
        if(item.id === itemId.id && item.quantity > 1) {
          const newQuantity = item.quantity - 1;
          const newTotalPrice = newQuantity * itemPrice;
  
          const updatedItem = {
            ...item,
            quantity: newQuantity,
            totalPrice: newTotalPrice,
          };
  
          const storedQty = JSON.parse(localStorage.getItem("cart_quantities")) || {};
          storedQty[itemId.item_id] = newQuantity;
          localStorage.setItem("cart_quantities", JSON.stringify(storedQty));
  
          return updatedItem;
        }
        return item;
      });
  
      return updatedItems;
    });
  }, []);


  const handleUpdate = (itemId, quantity, totalPrice) => {
    const cart_id = localStorage?.getItem("cart_id") || null;
    const payload = {
      item_id: itemId,
      quantity,
      total_prize: totalPrice,
      ...(cart_id && { cart_id }),
    };
    dispatch(putCartItem(itemId, payload, toast));
  };

  const handleDelete = useCallback(async () => {
    console.log("Delete button clicked, item ID:", cartitemId);
    try {
      dispatch(deleteCartItem(cartitemId, toast));
      setCartItems((prevItems) =>
        prevItems.filter((item) => item?.id !== cartitemId)
      );
      toast.success("Item deleted successfully");
    } catch (error) {
      console.error("Error deleting item:", error);
      toast.error("Failed to delete item.");
    } finally {
      closeModal();
    }
  }, [dispatch, cartitemId, closeModal]);

  useEffect(() => {
    const initialSelectedState = cartItems.reduce((acc, item) => {
      acc[item.id] = item.selected; // Use item.selected for initial state
      return acc;
    }, {});
    setSelectedItems(initialSelectedState);
  }, [cartItems]);
  const handleCheckboxChange = async (e, itemId) => {
    try {
      const isChecked = e.target.checked;
      const payload = {
        selected: isChecked,
      };
      dispatch(PostAddSalectItems(payload, itemId, toast));
      setSelectedItems((prev) => ({ ...prev, [itemId]: isChecked }));
    } catch (error) {
      toast.error("An error occurred");
    }
  };

  const calculateDiscountPrice = (item) => {
    const discount = parseFloat(item.discount_price);
    const price = parseFloat(item.price);
  
    if (!discount || discount === 0) {
      return price;
    }
  
    return discount;
  };

  const getVariants = (item) => {
    const selectedVariants = JSON.parse(item.selected_variants || "{}");
    if(Object.keys(selectedVariants).length === 0) {
      return <span>N/A</span>;
    }
    
    const variantValues = Object.values(selectedVariants).map((variant) => variant?.value);
        return <span>{variantValues.join(" ")}</span>;
  };

  return (
    <>
      {minicart ? (
        <div className="mt-4 max-h-[450px] overflow-y-auto">
          {loading || cartIsLoading ? (
            <SkeletonLoader cartItems={cartItems} />
          ) : (
            cartItems.map((item, index) => (
              <div
                className={`flex shadow-md rounded-lg justify-between relative my-4 ${
                  index % 2 === 0 ? "" : "bg-gray-100"
                }`}
                key={index}
              >
                <div
                  className="flex items-center justify-center cursor-pointer h-8 w-8 rounded-md absolute right-[10px] top-[20px] p-2 bg-[#00000054]"
                  onClick={() => openModal(item?.id)}
                >
                  <RxCross2 className="text-2xl text-[#072320]" />
                </div>
                <div className="flex items-center py-4 px-4 gap-4">
                  <div className="rounded-md w-24 h-24 bg-[#00a762b0] relative p-2">
                    <div className="relative h-full w-full">
                      <img
                        src={BASE_IMAGE_URL + item?.additional_images[0]}
                        alt="product_img"
                        className="h-full w-full rounded-md"
                      />
                      <div className="absolute left-1 top-1">
                        <FormProvider>
                          <FormContent
                            isChecked={selectedItems[item.id]}
                            onCheckboxChange={(e) =>
                              handleCheckboxChange(e, item.id)
                            }
                          />
                        </FormProvider>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center flex-col gap-1">
                    <h2 className="text-[#00A762] text-left font-dm text-lg capitalize font-medium">
                      {item?.name}
                    </h2>
                    <h2 className="text-[#072320] text-left font-dm text-md capitalize font-medium">
                      Quantity : {item?.quantity}
                    </h2>
                    <h2 className="text-[#072320] text-left font-dm text-md capitalize font-medium">
                      Unit Price : ₹{calculateDiscountPrice(item)}
                    </h2>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200 shadow-md rounded-lg">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-2 px-4 font-dm text-[#00A762] capitalize ">
                  Image
                </th>
                <th className="py-2 px-4 font-dm text-[#00A762] capitalize">
                  Name
                </th>
                <th className="py-2 px-4 font-dm text-[#00A762] capitalize">
                  Price
                </th>
                <th className="py-2 px-4 font-dm text-[#00A762] capitalize">
                  Value
                </th>
                <th className="py-2 px-4 font-dm text-[#00A762] capitalize">
                  Quantity
                </th>
                <th className="py-2 px-4 font-dm text-[#00A762] capitalize">
                  Total Price
                </th>
                <th
                  className="py-2 px-4 font-dm text-[#00A762] capitalize"
                  colSpan={2}
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {cartItems.map((item) => {
                const unitPrice = item.discount ? parseFloat(item.discount) : parseFloat(item.price);
                const originalTotal = parseFloat(item.price) * item.quantity;
                const discountedTotal = unitPrice * item.quantity;            

                return (
                  <tr key={item.id}>
                    <td className="py-2 px-4">
                      <img
                        src={BASE_IMAGE_URL + item?.additional_images[0]}
                        alt="product_image"
                        className="w-16 h-16 object-cover"
                      />
                    </td>            

                    <td className="py-2 px-4">{item?.name}</td>        

                    <td className="py-2 px-4">
                      {(item.discount && parseFloat(item.discount) > 0 && parseFloat(item.discount) < parseFloat(item.price)) ? (
                        <div className="flex flex-col">
                          <span className="text-green-600 font-medium">
                            ₹{parseFloat(item.discount).toFixed(2)}
                          </span>
                          <span className="line-through text-gray-500 text-sm">
                            ₹{parseFloat(item.price).toFixed(2)}
                          </span>
                        </div>
                      ) : (
                        <span>₹{parseFloat(item.price).toFixed(2)}</span>
                      )}
                    </td>

                    <td className="py-2 px-4">{getVariants(item)}</td>            

                    <td className="py-2 px-4">
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => handleDecrement(item)}
                          className="p-2 border rounded-full"
                        >
                          <FiMinus />
                        </button>
                        <span>{item.quantity}</span>
                        <button
                          onClick={() => handleIncrement(item)}
                          className="p-2 border rounded-full"
                        >
                          <MdAdd />
                        </button>
                      </div>
                    </td>            

                    <td className="py-2 px-4">
                      {(item.discount && parseFloat(item.discount) > 0 && parseFloat(item.discount) < parseFloat(item.price)) ? (
                        <div className="flex flex-col">
                          <span className="text-green-600 font-medium">
                            ₹{(parseFloat(item.discount) * item.quantity).toFixed(2)}
                          </span>
                          <span className="line-through text-gray-500 text-sm">
                            ₹{(parseFloat(item.price) * item.quantity).toFixed(2)}
                          </span>
                        </div>
                      ) : (
                        <span>₹{(parseFloat(item.price) * item.quantity).toFixed(2)}</span>
                      )}
                    </td>

                    <td
                      className="py-2 cursor-pointer"
                      onClick={() =>
                        handleUpdate(item?.id, item?.quantity, discountedTotal)
                      }
                    >
                      <h1 className="text-[#00A762] font-dm">Update</h1>
                    </td>            

                    <td
                      className="py-2 cursor-pointer"
                      onClick={() => openModal(item?.id)}
                    >
                      <MdDeleteForever className="text-[#00A762] text-2xl" />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      {minicart ? (
        <Modelminidelete
          isOpen={isModalOpen}
          onClose={closeModal}
          onConfirm={handleDelete}
        />
      ) : (
        <Modeldelete
          isOpen={isModalOpen}
          onClose={closeModal}
          onConfirm={handleDelete}
        />
      )}
    </>
  );
}

const SkeletonTable = ({ cartItems }) => (
  <div className="grid grid-cols-1 gap-6">
    {cartItems.map((item, index) => (
      <div key={index} className="flex justify-between p-4 border-b">
        <div className="w-16 h-16 bg-gray-300 rounded-md" />
        <div className="w-1/3 bg-gray-300 h-6 rounded-md" />
        <div className="w-1/4 bg-gray-300 h-6 rounded-md" />
        <div className="w-1/4 bg-gray-300 h-6 rounded-md" />
      </div>
    ))}
  </div>
);

const SkeletonLoader = ({ cartItems }) => (
  <div className="flex flex-wrap gap-4">
    {cartItems.map((item, index) => (
      <div
        key={index}
        className="flex flex-col justify-between items-center w-48 h-72 bg-gray-300 rounded-lg p-4"
      >
        <div className="w-32 h-32 bg-gray-400 rounded-lg" />
        <div className="w-full bg-gray-400 h-4 mt-2 rounded-md" />
        <div className="w-full bg-gray-400 h-4 mt-2 rounded-md" />
      </div>
    ))}
  </div>
);

function FormContent({ isChecked, onCheckboxChange }) {
  return (
    <form className="w-fit">
      <label className="custom-checkbox">
        <input
          type="checkbox"
          checked={isChecked || false}
          onChange={onCheckboxChange}
        />
        <span className="checkmark"></span>
      </label>
    </form>
  );
}
